import React, { useContext } from "react";
import PropTypes from "prop-types";

// context
import MessageStackContext from "core/MessageStack/context";

// hooks
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// styles
import { MessageListStyled } from "./styles";

// components
import Message from "./Message";

const HEADER_HEIGHT = {
    expanded: 128,
    compact: 62
};
const MESSAGE_LIST_CUSHION = {
    small: 12,
    mediumLarge: 24
};

const getTop = (view, headerIsCompact) => {
    return (
        MESSAGE_LIST_CUSHION[view] +
        (headerIsCompact ? HEADER_HEIGHT.compact : HEADER_HEIGHT.expanded)
    );
};

const createDefaultAnchorPosition = (consumerOverride, headerIsCompact) => {
    // defaults for global app views
    const small = {
        top: getTop("small", headerIsCompact),
        right: MESSAGE_LIST_CUSHION.small,
        left: MESSAGE_LIST_CUSHION.small
    };
    const mediumLarge = {
        top: getTop("mediumLarge", headerIsCompact),
        right: MESSAGE_LIST_CUSHION.mediumLarge,
        left: "auto"
    };

    return {
        position: "fixed",
        small,
        mediumLarge,
        ...consumerOverride
    };
};

const MessageList = ({ anchorPosition = {} }) => {
    const {
        state: { messages },
        stackLimit
    } = useContext(MessageStackContext);

    const { isCompact } = useSiteHeader();

    return (
        <MessageListStyled
            anchorPosition={createDefaultAnchorPosition(
                anchorPosition,
                isCompact
            )}
        >
            {messages
                ?.filter((m, idx) => idx < stackLimit)
                .map((m, idx) => {
                    return (
                        <Message key={m.id} message={m} placeInLine={idx + 1} />
                    );
                })}
        </MessageListStyled>
    );
};

export default MessageList;

// prop-types
MessageList.propTypes = {
    anchorPosition: PropTypes.object
};
